/** Switches that are decisions rather than code. */

/** New organisations can connect. Lives in shared/signups.ts because the server enforces it too. */
export { SIGNUPS_OPEN } from "../../shared/signups";

/** Where the public, checkable email-reading code lives. The pages claim "public code", and show
 *  the link, only while this is set. */
export const PUBLIC_CODE_URL = "https://github.com/hafizuddin-a/confirmpay-public";
